// extracted by mini-css-extract-plugin
export default {"authSubmitButton":"Button_authSubmitButton__3GGJc","authLinkButton":"Button_authLinkButton__4l1vg"};